import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["pinLocation"];
import { forwardRef } from 'react';
import { TrellisBaseToolbar } from './BaseToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
// Give corner radius to the opposite corner of the pin location
const buttonRoundingFromPinLocation = pinLocation => {
  let firstButtonRounding;
  let lastButtonRounding;
  switch (pinLocation) {
    case 'left top':
    case 'top left':
      lastButtonRounding = 'bottom right';
      break;
    case 'left bottom':
    case 'bottom left':
      lastButtonRounding = 'top right';
      break;
    case 'right top':
    case 'top right':
      firstButtonRounding = 'bottom left';
      break;
    case 'bottom right':
    case 'right bottom':
      firstButtonRounding = 'top left';
      break;
    default:
      throw new Error(`Invalid pinLocation (${pinLocation})`);
  }
  return {
    firstButtonRounding,
    lastButtonRounding
  };
};
const BasePinnedToolbar = (props, ref) => {
  const {
      pinLocation
    } = props,
    otherProps = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    firstButtonRounding,
    lastButtonRounding
  } = buttonRoundingFromPinLocation(pinLocation);
  return /*#__PURE__*/_jsx(TrellisBaseToolbar, Object.assign({
    iconUse: "pinned",
    firstButtonRounding: firstButtonRounding,
    lastButtonRounding: lastButtonRounding,
    onlyLeftAndRightButtonBorders: true
  }, otherProps, {
    forwardedRef: ref
  }));
};
export const TrellisPinnedToolbar = /*#__PURE__*/forwardRef(BasePinnedToolbar);
TrellisPinnedToolbar.displayName = 'PinnedToolbar';
export default TrellisPinnedToolbar;